module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Attachment2-b8e1da0f3b97c0f898bd226fe484a1ed.svg";